/*
 |------------------------------------------------------------------------------
 | Enhanced ecommerce - Promotions
 |------------------------------------------------------------------------------
 */

import { baseEvent } from '.';
import { push } from '../../01-helpers/utilities/tag-manager';

/* ========================================================================== */

const keys = {
		courseId: 'courseId',
		name: 'name'
	},
	attributes = {
		[keys.courseId]: 'data-course-id',
		[keys.name]: 'data-course-name'
	},
	promoClickPredicates = {
		[keys.courseId]: (courseId) => (promo) => promo.id === courseId,
		[keys.name]: (name) => (promo) =>
			promo.name.toLowerCase() === name.toLowerCase()
	};

/* ========================================================================== */

export function pushPromoView(ecommerceData) {
	if (!ecommerceData?.promoView?.promotions?.length) {
		return;
	}

	push({
		...baseEvent,
		event: 'promoView',
		ecommerce: ecommerceData
	});
}

function pushPromoClickWithPredicate(ecommerceData, predicate) {
	const matchingPromotion = ecommerceData?.promoView?.promotions?.find(
		predicate
	);

	if (!matchingPromotion) {
		return;
	}

	push({
		...baseEvent,
		event: 'promoClick',
		ecommerce: {
			promoClick: {
				promotions: [
					matchingPromotion
				]
			}
		}
	});
}

function checkPromoClickByAttribute(
	attribute,
	clickedResultElement,
	ecommerceData
) {
	if (!clickedResultElement.hasAttribute(attributes[attribute])) {
		return;
	}

	const value = clickedResultElement.getAttribute(attributes[attribute]);

	if (value) {
		pushPromoClickWithPredicate(
			ecommerceData,
			promoClickPredicates[attribute](value)
		);
	}
}

export function pushPromoClick(clickedResultElement, ecommerceData) {
	checkPromoClickByAttribute(keys.name, clickedResultElement, ecommerceData);
	checkPromoClickByAttribute(keys.courseId, clickedResultElement, ecommerceData);
}
